import { render } from "./sidebar-signed.vue?vue&type=template&id=128f07f2"
import script from "./sidebar-signed.vue?vue&type=script&lang=js"
export * from "./sidebar-signed.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__